<template>
  <section>
    <div class="title mb-base">
      回收前您需要
    </div>
    <div class="quesition clearfix">
      <div class="q-item fl">
        <div class="q-img"></div>
        <div class="q-des">
          <p class="q-t">
            拔出SIM卡，备份个人数据
          </p>
          <p class="text-muted text-sz-descript">
            （最好恢复出厂设置）
            <span class="text-primary" @click="popupVisbile1 = true" ref="lm">如何备份？</span>
            <popover v-model="popupVisbile1" :append-to-body="true" visible-arrow :reference="$refs.lm">
              使用QQ同步助手
            </popover>
          </p>
        </div>
      </div>

      <div class="q-item fl">
        <div class="q-img"></div>
        <div class="q-des">
          <p class="q-t">
            交易时必须携带有效身份证
          </p>
          <p class="text-muted text-sz-descript">
            未成年人必须由监护人陪同，否则不能回收
          </p>
        </div>
      </div>

      <div class="q-item fl">
        <div class="q-img"></div>
        <div class="q-des">
          <p class="q-t">
            保持手机电量充足
          </p>
        </div>
      </div>

    </div>
  </section>
</template>

<style type="text/css" scoped>
@import 'config.css';

.title {
  font-size: 14px;
  padding: 15px 0;
  border-bottom: 1px solid #e5e8ed;
}

.q-item {
  width: 32%;
  margin-right: 2%;
}

.q-img {
  height: 200px;
  background: no-repeat center;
  background-size: cover;
}

.q-des {
  padding: 10px;
}

.q-item:nth-child(1) .q-img {
  background-image: url(//s1.huishoubao.com/static/pc/1335/img/mac.png);
}

.q-item:nth-child(2) .q-img {
  background-image: url(//s1.huishoubao.com/static/pc/1335/img/id.png);
}

.q-item:nth-child(3) {
  margin-right: 0;
}
.q-item:nth-child(3) .q-img {
  background-image: url(//s1.huishoubao.com/static/pc/1335/img/keep-power-full.png);
}

@media (--sm-viewport) {
  .q-item {
    width: 100%;
    margin-right: 0;
  }

  .q-img {
    width: 80px;
    height: 80px;
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 15px;
  }

  .q-des {
    display: inline-block;
  }
}

</style>

<script type="text/javascript">
import { Popover } from 'hsb_recycle_components';

export default {
  components: {
    Popover
  },
  data () {
    return {
      popupVisbile1: false
    };
  }
};
</script>
